const FORMULA_START = /^[=+\-@\t\r]/;
const NUMBER = /^[+-]?\d+(\.\d+)?$/;

/** One RFC 4180 cell. The design system's lone em dash means blank, so the file leaves it empty. */
function csvCell(value: string): string {
  if (value === '—') return '';
  const guarded = FORMULA_START.test(value) && !NUMBER.test(value) ? `'${value}` : value;
  return /[",\r\n]/.test(guarded) ? `"${guarded.replace(/"/g, '""')}"` : guarded;
}

export function toCsv(header: readonly string[], lines: ReadonlyArray<readonly string[]>): string {
  return [header, ...lines].map((line) => line.map(csvCell).join(',')).join('\r\n');
}

/** `name-YYYY-MM-DD.csv`. The date defaults to today's calendar date in the user's local time zone. */
export function csvFileName(name: string, date?: string): string {
  const now = new Date();
  const local = [now.getFullYear(), now.getMonth() + 1, now.getDate()]
    .map((part, index) => String(part).padStart(index === 0 ? 4 : 2, '0'))
    .join('-');
  return `${name}-${date ?? local}.csv`;
}

/** Saves the file in the browser. The BOM lets Excel read UTF-8. */
export function downloadCsv(fileName: string, csv: string): void {
  const url = URL.createObjectURL(new Blob(['\uFEFF', csv], { type: 'text/csv;charset=utf-8' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
}
